class DescriptionCollapse {
    constructor(descriptionCollapseElement) {
        this.descriptionCollapseElement = descriptionCollapseElement
        this.showButtonElement = this.descriptionCollapseElement.querySelector('.description-show-more-button')
        this.hideButtonElement = this.descriptionCollapseElement.querySelector('.description-show-less-button')
    }

    init() {
        if (!this.showButtonElement || !this.hideButtonElement) {
            return
        }
        this.initEventListeners()
    }

    initEventListeners() {
        this.showButtonElement.addEventListener('click', () => this.handleShowButtonClick())
        this.hideButtonElement.addEventListener('click', () => this.handleHideButtonClick())
    }

    handleShowButtonClick() {
        this.openDescription()
    }

    handleHideButtonClick() {
        this.closeDescription()
    }

    openDescription() {
        this.descriptionCollapseElement.classList.remove('closed')
    }

    closeDescription() {
        this.descriptionCollapseElement.classList.add('closed')
    }
}

export default function init() {
    const descriptionCollapseElements = document.querySelectorAll(
        '.description-collapsible-component, .media-links-collapsible-component, .mobile-book-grid-collapsible, .awards-collapsible-component, .news-collapsible-component, .adaptations-collapsible-component, .events-collapsible-component'
    );

    descriptionCollapseElements.forEach(descriptionCollapseElement => {
        const descriptionCollapse = new DescriptionCollapse(descriptionCollapseElement);
        descriptionCollapse.init()
    });
}
